var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        "content-css": { minWidth: "30vw" },
        "no-esc-dismiss": true,
        "no-backdrop-dismiss": true
      },
      model: {
        value: _vm.managerAffiliateModalOpen,
        callback: function($$v) {
          _vm.managerAffiliateModalOpen = $$v
        },
        expression: "managerAffiliateModalOpen"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-icon", { attrs: { name: "fa fa-user-plus" } }),
              _c("q-toolbar-title", [_vm._v("\n        Add Manager\n      ")]),
              _c("q-icon", {
                attrs: {
                  disabled: _vm.addingManagerToAffiliate,
                  name: "clear"
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.onClose($event)
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c(
              "div",
              { staticClass: "q-px-sm text-center" },
              [
                _c("h6", [_vm._v("Find Manager")]),
                _c(
                  "q-search",
                  {
                    model: {
                      value: _vm.filter,
                      callback: function($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter"
                    }
                  },
                  [
                    _c("q-autocomplete", {
                      ref: "managerAutoComplete",
                      attrs: {
                        "stack-label": "Search Managers",
                        debounce: 500,
                        "max-results": _vm.maxResults,
                        disabled: _vm.addingManagerToAffiliate
                      },
                      on: {
                        search: _vm.onSearchManager,
                        selected: _vm.onSelectManager
                      }
                    })
                  ],
                  1
                ),
                _vm.currentManagerAffiliateManager
                  ? _c("div", { staticStyle: { "margin-top": "40px" } }, [
                      _c(
                        "h6",
                        {
                          staticStyle: {
                            "font-size": "15px",
                            "margin-bottom": "5px"
                          }
                        },
                        [_vm._v("Selected Manager")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "label green round action cursor-pointer",
                          staticStyle: { "margin-left": "-10px" }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.currentManagerAffiliateManager.item
                                  .USER_FIRST_NAME[0]
                              ) +
                                _vm._s(
                                  _vm.currentManagerAffiliateManager.item
                                    .USER_LAST_NAME[0]
                                )
                            )
                          ])
                        ]
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.currentManagerAffiliateManager.item
                              .USER_FIRST_NAME
                          ) +
                          " " +
                          _vm._s(
                            _vm.currentManagerAffiliateManager.item
                              .USER_LAST_NAME
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c(
                "q-btn",
                {
                  attrs: {
                    color: "green",
                    disabled:
                      !_vm.currentManagerAffiliateManager ||
                      _vm.addingManagerToAffiliate
                  },
                  nativeOn: {
                    click: function($event) {
                      _vm.addManagerAffiliateMethod()
                    }
                  }
                },
                [_vm._v("Add")]
              ),
              _vm._v(" \n    "),
              _c(
                "q-btn",
                {
                  attrs: {
                    color: "secondary",
                    disabled: _vm.addingManagerToAffiliate,
                    outline: ""
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.onClose($event)
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.addingManagerToAffiliate
        ? _c(
            "q-inner-loading",
            [
              _c("q-spinner-gears", {
                attrs: { color: "primary", size: "70" }
              }),
              _c("span", [_vm._v("Adding Manager..")])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }